export const SAVE_VIRTUAL_AIRCRAFT_CONTRACT_ENTRY = 'SAVE_VIRTUAL_AIRCRAFT_CONTRACT_ENTRY';
export const SAVE_VIRTUAL_AIRCRAFT_CONTRACT_REQUEST = 'SAVE_VIRTUAL_AIRCRAFT_CONTRACT_REQUEST';
export const SAVE_VIRTUAL_AIRCRAFT_CONTRACT_SUCCESS = 'SAVE_VIRTUAL_AIRCRAFT_CONTRACT_SUCCESS';
export const SAVE_VIRTUAL_AIRCRAFT_CONTRACT_FAILURE = 'SAVE_VIRTUAL_AIRCRAFT_CONTRACT_FAILURE';
